import BaseAction from './BaseAction.js';
import StepData from 'pattern/StepData.js';

class BaseStepAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    serialize(action, id) {
        let json = super.serialize(action, id);
        let {operation} = json;
        operation.payload.step = operation.payload.step.getJson();
        return json;
    }

    deserialize(json) {
        let action = super.deserialize(json);
        let payload = action.payload;
        let track = payload.track;
        if (track === undefined) {
            // no track found
            return undefined;
        }

        payload.step = this.deserializeStep(
            payload.step,
            track,
            payload.stepNumber);
        return action;
    }
}

export default BaseStepAction;
